import { Box, Typography, ButtonBase } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { cloudflareCDN } from "ui";

interface StartingCardProps {
  img: string;
  title: string;
  subtitle: string;
  onClick: () => void;
}

/**
 * A clickable "starting option" card: bold title + subtitle over an illustration,
 * wrapped in a white rounded card with a circular arrow affordance — matching the
 * Mockups design. Used on the /starting-options page.
 */
export const StartingCard = ({
  img,
  title,
  subtitle,
  onClick,
}: StartingCardProps) => (
  <ButtonBase
    onClick={onClick}
    sx={{
      flex: 1,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: "#fff",
      borderRadius: 5,
      p: { xs: 2.5, md: 3, lg: 4 },
      boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
      transition: "transform .15s, box-shadow .15s",
      "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: "0 18px 44px rgba(0,0,0,0.18)",
      },
    }}
  >
    <Typography
      sx={{
        fontWeight: 800,
        fontSize: { xs: 20, md: 24, lg: 28, xl: 32 },
        lineHeight: 1.1,
        color: "#111",
      }}
    >
      {title}
    </Typography>
    <Typography
      sx={{
        mt: 0.5,
        fontSize: { xs: 13, md: 15, lg: 17, xl: 19 },
        color: "#9a9aa0",
      }}
    >
      {subtitle}
    </Typography>
    <Box
      sx={{
        mt: 2,
        width: "100%",
        backgroundColor: "#f4f4f6",
        borderRadius: 4,
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={cloudflareCDN(
          window.location.origin + img,
          "width=1100,fit=scale-down,format=auto",
        )}
        alt={title}
        sx={{ width: "100%", height: "auto", display: "block" }}
      />
    </Box>
    <Box
      sx={{
        width: "100%",
        mt: "auto",
        pt: 2,
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Box
        sx={{
          width: { xs: 44, lg: 52 },
          height: { xs: 44, lg: 52 },
          borderRadius: "50%",
          backgroundColor: "#111",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ArrowForwardIcon fontSize="small" />
      </Box>
    </Box>
  </ButtonBase>
);
